import React from 'react';
import { Link } from 'react-router-dom';
import FeatureFlag from '../../Features/components/FeatureFlag';
import { FeatureFlags } from '../../Features/lib/constants';
import { remoteControlPath } from '../routes';

export default function RemoteControlLink({
    orgId,
    deviceKeyId,
    interfaceVersion = 'v1',
    className,
    children = 'Remote',
}: {
    orgId: number;
    deviceKeyId: string;
    interfaceVersion?: 'v1' | 'v2';
    className?: string;
    children?: React.ReactNode;
}) {
    return (
        <FeatureFlag flag={FeatureFlags.REMOTE_CONTROL_V1}>
            <Link
                to={remoteControlPath(orgId, deviceKeyId, interfaceVersion)}
                className={className}
            >
                {children}
            </Link>
        </FeatureFlag>
    );
}
